/**
 * Mail template form layout script class
 *
 * @package    Layouts
 * @author     Roman Kritskiy <rkritskiy@mindk.com>
 * @copyright  Copyright (c) 2010-2018 MindK (http://mindk.com). All rights reserved.
 * @license    http://mindk.com
 * @link       http://mindk.com
 */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { reduxForm, Field } from 'redux-form';
import { FormattedMessage } from 'react-intl';

import Button from 'Common/CustomButtons/Button';
import { CustomFormInput } from 'Common/Form';
import { FormEditor } from 'Common/ReduxForm';
import FormGroup from 'Components/FormGroup/FormGroup';
import { requiredValidation, maxLengthValidation } from 'Utils';
import Clearfix from 'Common/Clearfix/Clearfix';

const maxLength255 = maxLengthValidation(255);

@reduxForm({
    form: 'update_mail_template',
    enableReinitialize: true,
})
export default class MailTemplateForm extends PureComponent {
    /**
     * @type {Object}
     */
    static propTypes = {
        handleSubmit: PropTypes.func.isRequired,
        submitting: PropTypes.bool,
        pristine: PropTypes.bool,
        initialValues: PropTypes.object,
    };

    /**
     * @type {Object}
     */
    static contextTypes = {
        intl: PropTypes.object.isRequired,
    };

    render() {
        const { handleSubmit, pristine, submitting } = this.props;

        return (
            <form onSubmit={handleSubmit} id="update_mail_template">
                <FormGroup required>
                    <Field
                        withLabel
                        rowClassName="mm-form-field"
                        name="title"
                        component={CustomFormInput}
                        type="text"
                        label="title"
                        placeholder="title"
                        validate={[requiredValidation, maxLength255]}
                    />
                    <Field
                        withLabel
                        rowClassName="mm-form-field"
                        name="subject"
                        component={CustomFormInput}
                        type="text"
                        label="subject"
                        placeholder="subject"
                        validate={[requiredValidation, maxLength255]}
                    />
                    <Field
                        withLabel
                        rowClassName="mm-form-field"
                        name="body"
                        component={FormEditor}
                        label="body"
                        placeholder="body"
                    />
                </FormGroup>

                <Button round color="success" disabled={pristine || submitting} type="submit" right>
                    <FormattedMessage id="button.save" />
                </Button>

                <Clearfix />
            </form>
        );
    }
}



// WEBPACK FOOTER //
// ./src/layouts/Settings/components/SettingsMailForm.jsx